import React, { useState } from 'react';
import { X, Plus, Clock, Check, X as XIcon, GripVertical } from 'lucide-react';
import AntdTimePicker from './AntdTimePicker';

const TimeManagementModal = ({ 
  isOpen, 
  onClose, 
  timeSlots, 
  onUpdateTimeSlots 
}) => {
  const [editingTimes, setEditingTimes] = useState([...timeSlots]);
  const [newTime, setNewTime] = useState('');

  if (!isOpen) return null;

  const handleAddTime = () => {
    if (newTime.trim() && !editingTimes.includes(newTime.trim())) {
      setEditingTimes([...editingTimes, newTime.trim()]);
      setNewTime('');
    }
  };

  const handleTimeChange = (time) => {
    setNewTime(time);
  };

  const handleRemoveTime = (index) => {
    const newTimes = editingTimes.filter((_, i) => i !== index);
    setEditingTimes(newTimes);
  };

  const handleSave = () => {
    onUpdateTimeSlots(editingTimes);
    onClose();
  };

  const handleCancel = () => {
    setEditingTimes([...timeSlots]);
    onClose();
  };


  // 拖拽排序功能
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData('text/plain'));
    
    if (dragIndex !== dropIndex) {
      const newTimes = [...editingTimes];
      const draggedItem = newTimes[dragIndex];
      newTimes.splice(dragIndex, 1);
      newTimes.splice(dropIndex, 0, draggedItem);
      setEditingTimes(newTimes);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-4xl relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Clock size={20} className="mr-2" />
            时间管理
          </h3>
        </div>

        <div className="modal-body">
          {/* 添加新时间 */}
          <div className="mb-6">
            <h4 className="text-md font-medium text-gray-800 mb-3">添加新时间</h4>
            <div className="space-y-4">
              <AntdTimePicker
                value={newTime}
                onChange={handleTimeChange}
                placeholder="选择时间范围"
                className="w-full"
              />
              <button className="btn btn-success w-full" onClick={handleAddTime}>
                <Plus size={16} className="mr-2" />
                添加时间
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              选择开始时间和结束时间，系统会自动生成时间范围
            </p>
          </div>

          {/* 时间列表 */}
          <div className="mb-6">
            <h4 className="text-md font-medium text-gray-800 mb-3">时间列表（可拖拽排序）</h4>
            <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg">
              {editingTimes.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                  <Clock size={32} className="mx-auto mb-2 text-gray-300" />
                  <p>暂无时间，请添加时间</p>
                </div>
              ) : (
                <div className="space-y-1 p-2">
                  {editingTimes.map((time, index) => (
                    <div
                      key={index}
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, index)}
                      className="flex items-center gap-3 p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-move"
                    >
                      <GripVertical size={16} className="text-gray-400" />
                      <span className="flex-1 text-sm font-medium text-gray-700">
                        {time}
                      </span>
                      <button
                        onClick={() => handleRemoveTime(index)}
                        className="text-red-500 hover:text-red-700 transition-colors duration-200 p-1 rounded-full hover:bg-red-50"
                        title="删除此时间"
                      >
                        <X size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleSave}>
            <Check size={16} className="mr-2" />
            保存
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeManagementModal;
